/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { addModal } from 'core/notifications';

import TreeItemSelectorModalContainer from '../containers/treeItemSelectorModalContainer';

export default ({ item, onActionButtonClick, options }) => {
  const { modalOptions, ...treeItemSelectorOptions } = options;

  addModal({
    component: (
      <TreeItemSelectorModalContainer
        item={item}
        onActionButtonClick={onActionButtonClick}
        {...treeItemSelectorOptions}
      />
    ),
    hasCloseButton: true,
    ...modalOptions,
  });
};
